import DebounceLink from 'apollo-link-debounce';

const debounceLink = new DebounceLink(400);

export default debounceLink;
